'use es6';

import Client from 'AdsUI/data/Client';
import { ALL_NETWORKS } from 'AdsUI/lib/Constants';
const manageUrl = 'ads/v1/manage-ui';
export default {
  fetch() {
    return Client.apiRequest(`${manageUrl}/table-column-info`);
  },

  update(backEndEntityType, network, columnOrder) {
    const url = network === ALL_NETWORKS ? `${manageUrl}/table-column-order/${backEndEntityType}` : `${manageUrl}/table-column-order/${backEndEntityType}/${network}`;
    return Client.apiRequest(url, {
      type: 'PUT',
      query: {
        columnOrder
      }
    });
  }

};